import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import { createAggregationParams, createSearchParams, type ElasticsearchQueryFilter } from '@/shared/api/openmetadata';

import type { OpenMetadataResponse } from '@/entities/search';

export const fetchIcebergDatabases = async (params: { serviceName: string }): Promise<OpenMetadataResponse> => {
  const queryFilter: ElasticsearchQueryFilter = {
    query: {
      bool: {
        must: [{ term: { serviceType: 'iceberg' } }, { term: { 'service.displayName.keyword': params.serviceName } }],
      },
    },
  };

  const queryParams = createSearchParams('database_search_index', 1000, queryFilter, 'columns');

  const response = await openMetadataApiClient.get<OpenMetadataResponse>(`/search/query`, {
    params: queryParams,
  });

  return response.data;
};

export const fetchIcebergSchemas = async (params: {
  serviceName: string;
  databaseName: string;
}): Promise<OpenMetadataResponse> => {
  const queryFilter: ElasticsearchQueryFilter = {
    query: {
      bool: {
        must: [
          { term: { serviceType: 'iceberg' } },
          { term: { 'service.displayName.keyword': params.serviceName } },
          { term: { 'database.displayName': params.databaseName } },
        ],
      },
    },
  };

  const queryParams = createAggregationParams('dataAsset', queryFilter);

  const response = await openMetadataApiClient.get<OpenMetadataResponse>(`/search/query`, {
    params: queryParams,
  });

  return response.data;
};

export const fetchIcebergTables = async (params: {
  serviceName: string;
  databaseName: string;
  schemaName: string;
}): Promise<OpenMetadataResponse> => {
  const queryFilter: ElasticsearchQueryFilter = {
    query: {
      bool: {
        must: [
          { term: { serviceType: 'iceberg' } },
          { term: { 'service.displayName.keyword': params.serviceName } },
          { term: { 'database.displayName': params.databaseName } },
          { term: { 'databaseSchema.displayName': params.schemaName } },
        ],
      },
    },
  };

  const queryParams = createAggregationParams('dataAsset', queryFilter);

  const response = await openMetadataApiClient.get<OpenMetadataResponse>(`/search/query`, {
    params: queryParams,
  });

  return response.data;
};
